<template>
	<div>
		<div v-if="total_menu > 0" class="position-relative" style="z-index: 1028">
	    <div class="row no-gutters justify-content-center">
	      <div class="fixed-bottom d-block nav-bottom " :class="!full_bottom?'push-to-top':''">
	        <div class="custom-container-fluid px-0">
	          <div class="row justify-content-center no-gutters">
	            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	              <div class="container px-4 bg-white" :class="!full_bottom?'height-75px':'pb-3'">
	                <div class="row justify-content-center slim-grid-row">
	                  <div class="col-12">
	                    <router-link :to="'/'+getMerchant().code+cart_link">
	                      <div class="radius-12 bg-green w-100 px-3 py-2 box-shadow-bottom-nav">
	                        <div class="row no-gutters">
	                          <div class="col-6 no-ws align-self-center">
	                            <img 
	                            	src="../../../../assets/img/icon/svg-buy.svg" 
	                            	width="20" 
	                            	class="d-inline-block align-middle">
	                            <p class="text-white ml-2 mb-0 body-2-4 d-inline-block align-middle">
	                            	{{total_menu > 1 ? `${total_menu} ${item_title}s` : `${total_menu} ${item_title}`}}
	                            </p>
	                          </div>
	                          <div class="col-6 text-right align-self-center">
	                            <p class="text-white mb-0 body-3-1">
	                            	Total
	                            </p>
	                            <p class="text-white mb-0 body-1-1">{{formatCurrency(total_price)}}</p>
	                          </div>
	                        </div>
	                      </div>
	                    </router-link>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex';
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
	export default{
		props: {
			item_title:{
				type: String,
				default: 'Menu'
			},
			cart_link:{
				type: String,
				default: '/concierge/room-dining/cart'
			},
			is_cart_custom: {
				type: Boolean,
				default: false
			},
			full_bottom:{
				type: Boolean,
				default: false
			}
		},
		computed:{
			total_menu(){
				let total = 0

				let cart_list = this.is_cart_custom ? this.getConciergeOrder().custom : this.getConciergeOrder().cart

				for(let cart of cart_list){
					if(this.is_cart_custom){
						total += cart.form.qty
					}else{
						total += cart.qty
					}
				}
				return total
			},
			total_price(){
				if(this.is_cart_custom){
					let total = 0
					for(let cart of this.getConciergeOrder().custom){
						total += calculateFinalPriceConcierge(cart.product.price) * cart.form.qty
					}
					return total
				}else{
					let total = 0
					for(let cart of this.getConciergeOrder().cart){
						if(cart.product.is_variant){
							for(let variant of cart.variant){
								let base_price = cart.product.variant_type == 'notes' ? cart.product.data.price : variant.data.price
								total += calculateFinalPriceConcierge(base_price) * variant.qty
							}
						}else{
							total += calculateFinalPriceConcierge(cart.product.data.price) * cart.qty
						}
					}

					return total
				}
			}
		},
		methods:{
			...mapGetters(['getConciergeOrderTotal','getMerchant','getConciergeOrder']),
			formatCurrency(value){
        return formatCurrency(value);
      },
		}
	}
</script>
<style>
	.push-to-top{
		bottom:46px
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/cartPopup.vue